import type { ProcessedPost } from './types';

// Mock data for development
const MOCK_POSTS: ProcessedPost[] = [
  {
    id: '1',
    slug: '50-dollar-challenge',
    title: 'The $50 Challenge: How Pocket Change Can Buy You a House',
    content: `# The $50 Challenge: How Pocket Change Can Buy You a House (No, Really!)

Ever looked at your spare change and thought, "What if this could buy me a house?" Well, grab your piggy bank and buckle up, because we're about to embark on a mind-bending journey that'll make you see those crumpled bills in a whole new light!...`,
    excerpt: 'Discover how saving just $50 a month can grow into a substantial house down payment...',
    coverImage: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=1200&h=600&fit=crop',
    category: 'Finance',
    tags: ['Investing', 'Real Estate', 'Personal Finance'],
    author: {
      name: 'Alex Chen',
      avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop',
      role: 'Financial Advisor'
    },
    publishedAt: '2024-02-20T10:00:00Z',
    views: 1250,
    comments: 23,
    likes: 89,
    featured: true
  },
  {
    id: '2',
    slug: 'future-of-personal-optimization',
    title: 'The Future of Personal Optimization',
    content: `# The Future of Personal Optimization

In this comprehensive guide, we'll explore how emerging technologies are transforming the landscape of personal development and optimization...`,
    excerpt: 'Explore how AI and biotechnology are revolutionizing personal development...',
    coverImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&h=600&fit=crop',
    category: 'Technology',
    tags: ['AI', 'Future', 'Optimization'],
    author: {
      name: 'Alex Chen',
      avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop',
      role: 'Technology Analyst'
    },
    publishedAt: '2024-02-19T15:00:00Z',
    views: 980,
    comments: 15,
    likes: 67,
    featured: true
  }
];

export const loadPost = (slug: string): ProcessedPost | null => {
  return MOCK_POSTS.find(post => post.slug === slug) || null;
};

export const loadAllPosts = (): ProcessedPost[] => {
  return MOCK_POSTS;
};